const resources = {
    showMore: 'Afficher plus',
    rougeBadge: 'ROUGE'
};

export default function getResource(label) {
    return resources[label];
}
